<template lang="pug">
  v-dialog(v-model="showDeleteBillingDialog"
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    max-width="600"
    persistent)
    v-snackbar( v-model="snackbar" :color="snackbarColor" ) {{ snackbarMessage }}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="errorSnackbar = false") {{ $t('buttons.closeButtonLabel') }}
    v-card.d-flex.flex-column(max-height="450")
      v-card-title {{ $t('billingPage.deleteBillingDialogTextLabel') }} {{ titleFormat }}
      v-card-text.flex-grow-1.overflow-auto
        v-list()
          v-list-item( v-for="(billing, idx) in selectedBillings" :key="idx" link)
            v-list-item-content {{ billing.name }} {{ billing.name }} {{ billing.name }}
            v-list-item-content.font-weight-black.justify-center {{ boarderName(billing) }}
      v-divider
      v-card-actions.justify-end
        v-spacer
        v-btn( @click="onCloseButtonClick" text color="primary" ) {{ $t('buttons.closeButtonLabel') }}
        v-btn( @click="onDeleteButtonClick" color="primary" ) {{ $t('buttons.deleteButtonLabel') }}
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import {BillingData} from "@/types/service-response";

@Component({
  components: {}
})

export default class DeleteBillingDialog extends Vue {

  @Prop({type: Boolean, default: false}) showDeleteBillingDialog!: boolean
  @Prop({type: Array }) selectedBillings!: BillingData[]

  private deleteInProgress: boolean = false
  private wasDeleted: boolean = false

  private snackbar: boolean = false
  private snackbarMessage: string = ''
  private snackbarColor: string = ''

  get titleFormat(): string {
    if (this.selectedBillings.length === 1) {
      return ' ' + this.$t('billingPage.thisBilling')
    } else {
      return ' ' + this.$t('billingPage.thoseBillings')
    }
  }

  getHoverClass() {
    return 'background-color: #0F83E8'
    }

  boarderName(billing: any): string {
    return billing.boarder.person.firstName + ' ' + billing.boarder.person.familyName
  }

  onDeleteButtonClick(): void {
    this.deleteBilling()
  }

  async deleteBilling(): Promise<void> {

    this.deleteInProgress = true

    try {
      this.wasDeleted = true
      this.closeDialog()
    } catch (e) {
      this.snackbar = true
      this.snackbarMessage = this.$t('errors.deleteDataError').toString()
      this.snackbarColor = 'error'
    } finally {
      this.deleteInProgress = false
      this.wasDeleted = false
    }
  }

  onCloseButtonClick(): void {
    this.closeDialog()
  }

  closeDialog(): void {
    this.$emit('closeDialog', this.wasDeleted)
  }
}
</script>

<style lang="stylus" scoped>

.thisContainer {
  max-height 400px !important
}

</style>